var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container d-flex justify-content-center align-items-center",staticStyle:{"height":"400px"}},[_c('div',{staticClass:"text-center text-muted"},[_c('h3',[_vm._v("Consulta de voucher encerrada")])])])
}]

export { render, staticRenderFns }